
<template>
  <div>
    <p v-if="isTitle" class="title">Suggested Tags</p>

    <div class="container">
      <div  v-for="key in keys" :key="key" :class="isActiveTab(key)" @click="changeActiveTab(key)">
        {{key}}
      </div>
    </div>

    <div class="columns is-multiline is-desktop is-mobile mb-10">
      <div v-for="tag in options[activeTab]" :key="tag" class="column is-half-mobile is-4-tablet is-4-desktop is-one-third-widescreen is-one-fifth-fullhd">
        <job-tag :active="isActive(tag)"   @addTag="addTag" @removeTag="removeTag" :name="tag" :value="tag"></job-tag>
      </div>
    </div>
  </div>
</template>

<script>
import JobTag from '../general/job-tag.vue'
import Columns from '../general/columns.vue'
import Column from '../general/column.vue'
export default {
  name: 'SuggestedTags',
  components: {
    JobTag,
    Columns,
    Column
  },
  props: {
    options: {
      type: Object
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array
    },
    onChangeTag: {
      type: Function
    }
  },
  data () {
    return {
      activeTab: 'Ecosystem'
    }
  },
  computed: {
    keys () {
      if (Object.keys(this.options).length > 0) { return Object.keys(this.options) }
      return []
    }
  },
  methods: {
    addTag (value) {
      this.$emit('addTag', value
      )
    },
    removeTag (value) {
      this.$emit('removeTag', value)
    },
    isActive (value) {
      const found = this.value.findIndex(tag => tag === value)
      if (found === -1) {
        return false
      }
      return true
    },
    changeActiveTab (value) {
      this.activeTab = value
    },
    isActiveTab (tab) {
      return this.activeTab === tab ? 'active' : 'not-active'
    }
  }
}
</script>

<style scoped>
.title{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #979797;
  margin-bottom: 10px;
}
.mb-10{
  margin-bottom: 10px;
}

.container {
  display: flex;
  flex-flow: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.active{
  background: #44C7F0;
  border: 2px solid #44C7F0;
  border-radius: 35px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  padding: 6px 16px;
  cursor: pointer;
  color: #F9F9F9;
}

.not-active{
  border: 2px solid #44C7F0;
  border-radius: 35px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  cursor: pointer;
  color: #44C7F0;
  padding: 6px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/suggested-tags.vue